import PropTypes from 'prop-types'
import React from 'react'
import serializeForm from 'form-serialize'


const propTypes = {
  pendingRequest: PropTypes.object,
  handleClickResume: PropTypes.func.isRequired,
}

const defaultProps = {
  pendingRequest: null,
}


class ProxyEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edited: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.stringifyHeaders = this.stringifyHeaders.bind(this)
    this.buildRequestText = this.buildRequestText.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleSubmit(e) {
    e.preventDefault()
    const values = serializeForm(e.target, { hash: true })
    this.props.handleClickResume(values, this.state.edited)
    this.setState({ edited: false })
  }

  handleChange() {
    this.setState({ edited: true })
  }

  // TODO: Consider implementing this as a selector that's shared with ProxyHistory
  stringifyHeaders(h) {
    return `${Object.keys(h).map(k => `${k.toLowerCase()}: ${h[k]}`).join('\n')}\n`
  }

  buildRequestText(req) {
    const headers = this.stringifyHeaders(req.headers)
    return `${req.method} ${req.path} ${req.http_version}\n\n${headers}\n${req.body || ''}`
  }

  render() {
    const { intercept, pendingRequest } = this.props
    return (
      <div>
        {pendingRequest && intercept ? (
          <form onSubmit={this.handleSubmit}>
            <span className="uk-text-bold">
              <span>
                Request to: http://sandbox-hackedu.com{pendingRequest.path}
              </span>
            </span>
            <div className="uk-margin">
              <textarea
                onChange={this.handleChange}
                name="request"
                spellCheck="false"
                style={{
                  width: 874,
                  height: 350,
                  resize: 'none',
                  padding: 14,
                  background: '#333',
                  color: '#EEE',
                }}
                defaultValue={this.buildRequestText(pendingRequest)}
                data-uk-htmleditor
              />
            </div>
            <div className="uk-margin">
              <button
                className="uk-button uk-button-danger"
                data-test-id="proxy-submit-request-btn"
                type="submit"
              >
                Submit Request
              </button>
            </div>
          </form>
        )
          : (
            <p data-test-id="no-pending-request-msg">
              There are no pending requests to submit.
            </p>
          )}
      </div>
    )
  }
}

ProxyEditor.propTypes = propTypes
ProxyEditor.defaultProps = defaultProps


export default ProxyEditor
